/**
 * Primary UI component for user interaction
 */
export const analytics = (event, data={}) => {
  const obj = data;
  obj.event = event;
  if(window.dataLayer) window.dataLayer.push(obj);

  console.log('gtm', obj);
  return null;
};
